// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.utilisateur_profile_form {
    display: flex;
    justify-content: center;
    margin: auto;
    border: solid 1px var(--gris-secondaire);
    box-shadow:
    0 0 5px rgba(0, 0, 0, 0.05),
    0 0 10px rgba(0, 0, 0, 0.05),
    0 0 15px rgba(0, 0, 0, 0.08),
    0 0 20px rgba(0, 0, 0, 0.1);
    background-color: var(--white-principale);
    margin-top: 50px;
    margin-bottom: 50px;
    padding: 50px;
    border-radius: 20px;
}

.utilisateur_profile_form input[type="text"],
input[type='tel'] {
    padding: 15px;
    border-radius: 100px;
}
.utilisateur_profile_form input[type="file"] {
    border-radius: 100px;
    height: 40px;       /* hauteur totale */
    line-height: 40px;  /* aligne le texte verticalement */
    padding: 0 15px;    /* espace à gauche et droite */
    font-size: 14px;    /* taille du texte */
    margin-bottom: 20px;

}
.utilisateur_profile_form input:focus,
input:active {
    outline: none;
    box-shadow: none;
}
.utilisateur_profile_form label {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
}

.utilisateur_profile_form_button {
    display: flex;
    justify-content: center;
}

.utilisateur_profile_form_button button {
    background-color: var(--couleur-principale);
    border: solid 2px var(--couleur-principale);
    border-radius: 100px;
    padding: 10px;
    color: var(--white-principale);
    margin-top: 20px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    width: 50%;
}

.utilisateur_profile_form_button button:hover {
    background-color: var(--couleur-secondaire);
    border: solid 2px var(--couleur-secondaire);
}
.utilisateur_profile_container_photo{
    width: 100px;
    height: 100px;
    border: solid 1px var(--gris-secondaire);
    border-radius: 50%;
    overflow: hidden;
    margin: auto;
    text-align: center;
}


@media (max-width: 600px) {
    .utilisateur_profile_form_button button {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/utilisateur/utilisateurProfile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,wCAAwC;IACxC;;;;+BAI2B;IAC3B,yCAAyC;IACzC,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,oBAAoB;IACpB,YAAY,QAAQ,mBAAmB;IACvC,iBAAiB,GAAG,kCAAkC;IACtD,eAAe,KAAK,8BAA8B;IAClD,eAAe,KAAK,oBAAoB;IACxC,mBAAmB;;AAEvB;AACA;;IAEI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;AAC/C;AACA;IACI,YAAY;IACZ,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".utilisateur_profile_form {\n    display: flex;\n    justify-content: center;\n    margin: auto;\n    border: solid 1px var(--gris-secondaire);\n    box-shadow:\n    0 0 5px rgba(0, 0, 0, 0.05),\n    0 0 10px rgba(0, 0, 0, 0.05),\n    0 0 15px rgba(0, 0, 0, 0.08),\n    0 0 20px rgba(0, 0, 0, 0.1);\n    background-color: var(--white-principale);\n    margin-top: 50px;\n    margin-bottom: 50px;\n    padding: 50px;\n    border-radius: 20px;\n}\n\n.utilisateur_profile_form input[type=\"text\"],\ninput[type='tel'] {\n    padding: 15px;\n    border-radius: 100px;\n}\n.utilisateur_profile_form input[type=\"file\"] {\n    border-radius: 100px;\n    height: 40px;       /* hauteur totale */\n    line-height: 40px;  /* aligne le texte verticalement */\n    padding: 0 15px;    /* espace à gauche et droite */\n    font-size: 14px;    /* taille du texte */\n    margin-bottom: 20px;\n\n}\n.utilisateur_profile_form input:focus,\ninput:active {\n    outline: none;\n    box-shadow: none;\n}\n.utilisateur_profile_form label {\n    font-size: 16px;\n    font-weight: 700;\n    margin-bottom: 10px;\n}\n\n.utilisateur_profile_form_button {\n    display: flex;\n    justify-content: center;\n}\n\n.utilisateur_profile_form_button button {\n    background-color: var(--couleur-principale);\n    border: solid 2px var(--couleur-principale);\n    border-radius: 100px;\n    padding: 10px;\n    color: var(--white-principale);\n    margin-top: 20px;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: 700;\n    width: 50%;\n}\n\n.utilisateur_profile_form_button button:hover {\n    background-color: var(--couleur-secondaire);\n    border: solid 2px var(--couleur-secondaire);\n}\n.utilisateur_profile_container_photo{\n    width: 100px;\n    height: 100px;\n    border: solid 1px var(--gris-secondaire);\n    border-radius: 50%;\n    overflow: hidden;\n    margin: auto;\n    text-align: center;\n}\n\n\n@media (max-width: 600px) {\n    .utilisateur_profile_form_button button {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
